import React, {useState} from "react";
import Button from "components/ui/Button";
import InfoRow from "components/ui/InfoRow";
import Icon from "components/AppIcon";
import { submitBookingCollection, createOTP } from "services/bookingService";
import { toast } from "react-toastify";

const CollectionModal = ({
  onSuccessfulCollection,
  onCancellation,
  open=false,
  booking
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [resendingOtp, setResendingOtp] = useState(false);
    const [collectionVerified, setCollectionVerified] = useState(false);

    if (!open) return null;

    const handleVerifyOTP= async ()=>{
        if(otp.trim() === ''){
            toast.info('Please enter OTP');
            return;
        }
        setIsLoading(true);
        var results = await submitBookingCollection(booking.businessId, booking.id, { otp: otp.trim() });
        if(results.success){
            toast.success('Vehicle collection successful');
            //onSuccessfulCollection(booking.id);
            setCollectionVerified(true);
        }
        else{
            toast.error(results.message || 'Failed to verify OTP. Please try again.');
        }
        setOtp('');
        setIsLoading(false);
    }

    const handleResendOTP= async ()=>{
        setResendingOtp(true);
        var results = await createOTP(booking.businessId, booking.id);
        if(results.success){
            toast.success('OTP resent successfully');
        }
        else{
            toast.error(results.message || 'Failed to resend OTP. Please try again.');
        }     
        setResendingOtp(false);
    }

    const handleOnCancellation = ()=>{
        setResendingOtp(false);
        setOtp('');
        setCollectionVerified(false);
        onCancellation();
    }

    return (
        <div className="fixed inset-0 z-1002 overflow-y-auto flex items-center justify-center px-2">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50  transition-opacity"
                onClick={handleOnCancellation}
            />
            {/* Modal */}
            <div className="relative bg-white dark:bg-gray-900 rounded-xl shadow-xl p-6 w-full max-w-md mx-4 z-10">
                <h2 className="text-lg text-center font-semibold mb-2 text-gray-900 dark:text-white">
                Vehicle Collection
                </h2>
                <hr />
                
                {/* Vehicle Details */}
                <div className="space-y-4 my-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* <InfoRow icon="User" label="Customer" value={booking?.name+' '+booking?.surname} />
                    <InfoRow icon="Phone" label="Customer" value={booking?.contactNumber} /> */}
                    <InfoRow icon="Car" label="Vehicle" value={booking.bookedItemDetails.colour+' '+booking.bookedItemDetails.name+' '+booking.bookedItemDetails.model} />
                    <InfoRow icon="ScanLine" label="Registration Number" value={booking?.bookedItemDetails.registrationNo} />
                    </div>
                </div>

                {/* OTP Details */}
                {!collectionVerified?
                <>
                    <div className="flex flex-col items-center mx-6 mt-6 border border-border rounded px-4 py-6 bg-gray-50 dark:bg-gray-800 shadow">
                        <label className="text-center text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Enter OTP to verify vehicle collection
                        </label>
                        <input
                            value={otp}
                            onChange={(e)=> setOtp(e.target.value)}
                            type="number"
                            className="text-center w-3/4 border border-border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                            placeholder="Enter OTP"
                        />
                    </div>
                    <div className="flex flex-col items-center mx-6 mt-4">
                            {/* <label className="text-sm text-black">Did't receive OTP?</label> */}
                            <div className="flex flex-row justify-center items-center space-x-2 mt-1 text-primary font-medium cursor-pointer" onClick={()=>handleResendOTP()}>
                                {resendingOtp? 
                                <>
                                    <span className="text-mute">Resending OTP, please wait...</span>
                                </>:
                                <>
                                    <Icon name='RefreshCcw' size={18} className=" mt-0.5 flex-shrink-0" />
                                    <span>Resend OTP</span>
                                </>
                                }
                            </div>
                    </div>

                    <div className="flex justify-center gap-2 mt-6">
                        <Button
                            onClick={onCancellation}
                            className="w-40 px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 transition"
                        >
                            Cancel Collection
                        </Button>
                        <Button
                            loading={isLoading}
                            onClick={()=>handleVerifyOTP()}
                            className="w-40 px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
                        >
                            Verify OTP
                        </Button>
                    </div>
                </>:
                <div className="flex flex-col items-center mx-6 mt-4 px-4 py-3 ">
                    <Icon name="CheckCircle" size={80} className="mb-4 text-green-600" />
                    <h3 id="CollectionSuccess" className="text-green-900 text-xl font-semibold mb-1">Collection Verified Successfully!</h3>
                    <Button
                        onClick={()=>{
                            onSuccessfulCollection(booking.id);
                            setCollectionVerified(false);
                        }}
                        className="w-40 px-4 py-2 rounded-md bg-green-500 text-white hover:bg-green-500/90 transition mt-6"
                    >
                        Close
                    </Button>
                </div>
                }
            </div>
        </div>
    );
};

export default CollectionModal;